<template>
	<div class="dashboard">
		<top-header></top-header>
       
		<b-container fluid class=" mt-2">
			
            <b-row class="mb-4" style="margin-top: 8%;">
                <b-col cols="12" md="12" class="px-4 d-block d-sm-block text-center">
                   
						  <div class="card mb-2" style="max-width: 40rem;margin-left: 25%;">
							
								<div class="card-body" >
									
									<!--<h3 class="card-title text-center">Thanks You</h3>-->
									  <p class="text-center promo-title" style="padding-top: 26px;">Thank You!</p>
									   <div class=" pt-1 d-none d-md-block" style="font-size:24px;">You have successfully registered as an {{$root.INFLUENCER_TEXT}}!</div>
									  <!-- <p style="padding-bottom: 20px;"><small>You'll shortly receive an email with next steps!</small></p> -->
									   <p style="padding-bottom: 20px;"><small>Account activation link has been emailed to you. Please check your Email.</small></p> 
								</div>
							</div>
					
                </b-col> 
			</b-row>
			
		</b-container>
		<b-container fluid>
			<product-swiper :products="related_products" :showQuickViewListener="$root.showQuickView" heading="Products You May Like"></product-swiper>
		</b-container>
		<top-footer></top-footer>
		<quickview :modaldata="$root.quickview_data"></quickview>
	</div>
</template>
<script>
/*import Header from "@/components/header-promo.vue";
import Footer from "@/components/footer-promo.vue";*/
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import ProductSwiper from "@/components/product-swiper.vue";
import Quickview from "@/components/quickview.vue";

export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'promo';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
		"product-swiper": ProductSwiper,
		"quickview": Quickview,
	},
	mounted(){ 
        /*let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-J5D103H4N0');
        document.head.appendChild(recaptchaScript);

        let s1 = document.createElement('script');
        s1.setAttribute('src', 'https://www.alluraa.com/js/js_main.js');
        document.head.appendChild(s1); */
        this.initload();
        
	},
	data() {
		return{
            modal_data: {
                price: 0,
                special_price: 0
            },
            mainProps: { fluidGrow: true, class: 'm1' },
			slide:0,
			related_products: [],
			url: this.$root.WEBURL+'relatedproducts',
			
		};
	},
	methods: {
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			self.axios.post(self.url, {
                accesskey: self.$session.get('access_key'),
                products: 1
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.related_products = response.data.result.related_products;
                    //console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		}
	},
	metaInfo() {
		return{
			title: 'Alluraa',
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa' },
                { name: 'description', content: 'alluraa' },
                { name: 'google-site-verification', content: 'C0WP9JxlesVhxC-oa2ieqde4w5HvgBehOytgMpiNktA' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
			]
		}
	}
}


</script>
